import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import {
  resolveGameTimingMode,
  type GameTimingMode,
} from "@utils/gameTiming";

/**
 * Patient pacing for cognitive games (standard vs relaxed / more time).
 */
export function useGameTimingMode(): GameTimingMode {
  const selectedPatient = useSelector(
    (state: RootState) => state.home.selectedPatient
  );
  return resolveGameTimingMode(selectedPatient?.gameTimingMode);
}
